/**
 * GuestJoin Component - Now using SDK
 * 
 * This is a thin wrapper around the SDK GuestJoin component
 * that integrates with the existing LiveKitRoomComponent
 */

import { GuestJoin as SDKGuestJoin } from '@hosaksham/livekit-meeting-sdk';
import { SECRETS_ENV } from '../../../../Config/firebase';
import { LiveKitRoom as LiveKitRoomComponent } from '../SubscriptionDetails/Components/LiveKitRoom';
import hoSakshamLogo from '../../../../assets/HosakshamOnlyLogo.png';
import hoSakshamHorizontal from '../../../../assets/HosakshamHorizontal.png';

const API_ENDPOINT = SECRETS_ENV.API_END_POINT;
const LIVEKIT_SERVER_URL = 'wss://hosaksham-7o3jzavj.livekit.cloud';

export default function GuestJoin() {
  return (
    <SDKGuestJoin
      apiEndpoint={API_ENDPOINT}
      livekitServerUrl={LIVEKIT_SERVER_URL}
      logoUrl={hoSakshamLogo}
      renderMeetingRoom={(props) => (
        <LiveKitRoomComponent
          roomName={props.roomName}
          meetingTitle={props.meetingTitle}
          token={props.token}
          serverUrl={LIVEKIT_SERVER_URL}
          participantName={props.participantName}
          userRole="student"
          tenantId={props.tenantId}
          subscriptionId={props.subscriptionId}
          subscriptionName={props.subscriptionName}
          onDisconnect={props.onDisconnect}
          onError={(error) => {
            console.error('LiveKit room error:', error);
            props.onDisconnect();
          }}
          initialMicEnabled={props.preJoinOptions.micEnabled}
          initialCameraEnabled={props.preJoinOptions.cameraEnabled}
          initialBackgroundEffect={props.preJoinOptions.selectedBackground}
          initialMediaStream={props.initialMediaStream}
          initialAudioDevice={props.preJoinOptions.selectedAudioDevice}
          initialVideoDevice={props.preJoinOptions.selectedVideoDevice}
        />
      )}
    />
  );
}
